import { Box, BoxProps } from "@chakra-ui/react";
import React from "react";

export const WhiteSpace: React.FC<BoxProps> = ({ height }) => (
  <Box height={height} />
);
